import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { KYCEntity } from './types/Kyc';

export default (makeCall: MakeCall) =>
  (userId: 'me' | number = 'me', kycUuid: string) =>
    makeCall<KYCEntity>('GET', `/api/v2/user/${userId}/kyc/${kycUuid}`);
